import { Button } from "components/Button";
import { Card, CardHeader } from "components/Card";
import { Input } from "components/Input";
import {
  NOTIFICATION_TYPE,
  NotificationContext,
} from "context/NotificationContext";
import React, { useContext } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { AliErrorRecord } from "services/ALIErrorRecord";
import RecordService from "services/RecordService";
import { formatHouseNumber, formatPhoneNumber } from "utils/helpers";

const client = new RecordService("ali/error");

export default function ALIErrorDelete() {
  const { addNotification } = useContext(NotificationContext);

  const record: AliErrorRecord = useLoaderData() as AliErrorRecord;

  const navigate = useNavigate();

  const [isSaving, setIsSaving] = React.useState(false);

  function handleSubmit() {
    setIsSaving(true);
    client
      .deleteAliErrorRecord(record.idx)
      .then((res) => {
        setIsSaving(false);
        if (res.status === 200) {
          addNotification({
            title: "Success!",
            message: res.data.message.message,
            type: NOTIFICATION_TYPE.SUCCESS,
          });
          setTimeout(() => {
            navigate("/ali-errors");
          }, 1000);
        }
      })
      .catch((error) => {
        console.error("Error deleting ALI Error:", error);
        setIsSaving(false);
        addNotification({
          title: "Uh oh.",
          message: "Something went wrong: " + error.message,
          type: NOTIFICATION_TYPE.ERROR,
        });
      });
  }

  return (
    <div>
      <CardHeader>Delete ALI Error</CardHeader>
      <Card style={{ width: "100%", marginBottom: "20px" }}>
        <div style={{ padding: "20px", paddingBottom: "40px" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "100px",
            }}
          >
            {/* Left Column */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              <Input
                name="telephoneNumber"
                label="Telephone Number"
                value={formatPhoneNumber(record.CPN || "")}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="customerName"
                label="Customer Name"
                value={record.NAM || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="state"
                label="State"
                value={record.STA || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="mcn"
                label="MSAG Community Name"
                value={record.MCN || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="streetName"
                label="Street Name"
                value={record.STN || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="houseNumber"
                label="House Number"
                value={formatHouseNumber(record, record.HNO) || ""}
                readonly
                scale="s"
                labelSize="s"
              />
            </div>

            {/* Right Column */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              <Input
                name="foc"
                label="Function of Change"
                value={record.FOC || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="nenaId"
                label="NENA ID"
                value={record.CPF || ""}
                readonly
                scale="s"
                labelSize="s"
              />

              <Input
                name="classOfService"
                label="Class of Service"
                value={record.CLS || ""}
                readonly
                scale="s"
                labelSize="s"
              />

              <Input
                name="typeOfService"
                label="Type of Service"
                value={record.TYS || ""}
                readonly
                scale="s"
                labelSize="s"
              />
            </div>
          </div>

          <hr style={{ margin: "20px 0" }} />

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <Button
              variant="outline"
              kind="brand"
              label="Close"
              onClick={() => navigate(-1)}
            >
              Close
            </Button>
            <Button
              variant="solid"
              kind="danger"
              label="Delete Record"
              onClick={handleSubmit}
              disabled={isSaving}
              style={{ marginLeft: "10px" }}
            >
              Delete
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
